import { paymentApi } from "@/lib/payment-api";

const REFETCH_INTERVAL = 10000; // 10 seconds

export function useBalanceQuery() {
  return paymentApi.useQuery(
    "get",
    "/v1/balances",
    {},
    {
      refetchInterval: REFETCH_INTERVAL,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
    },
  );
}
